import { Link, useLocation } from "react-router-dom";
import { X, GitCompare } from "lucide-react";
import { useCompare } from "@/hooks/useCompare";

export const CompareTray = () => {
  const { items, remove, clear } = useCompare();
  const { pathname } = useLocation();
  if (!items.length || pathname.startsWith("/compare") || pathname.startsWith("/admin")) return null;
  return (
    <div data-testid="compare-tray" className="fixed bottom-24 sm:bottom-5 left-1/2 -translate-x-1/2 z-40 no-print w-[calc(100%-2rem)] sm:w-auto">
      <div className="flex flex-wrap items-center gap-2 rounded-full bg-[#0B2150] text-white pl-5 pr-2 py-2 shadow-2xl">
        <GitCompare className="h-4 w-4 text-[#63D8C4]" aria-hidden />
        <span className="text-sm font-medium mr-1">Compare ({items.length}/3)</span>
        {items.map((i) => (
          <span key={i.id} className="hidden md:inline-flex items-center gap-1 rounded-full bg-white/10 px-3 py-1 text-xs">
            {i.name.length > 22 ? `${i.name.slice(0, 22)}…` : i.name}
            <button onClick={() => remove(i.id)} aria-label={`Remove ${i.name}`} data-testid={`compare-tray-remove-${i.id}`}><X className="h-3 w-3" /></button>
          </span>
        ))}
        <button onClick={clear} className="text-xs text-slate-300 hover:text-white px-2" data-testid="compare-tray-clear">Clear</button>
        <Link to="/compare" data-testid="compare-tray-view-btn" className="rounded-full bg-[#03A896] px-4 py-2 text-sm font-semibold hover:bg-[#63D8C4] hover:text-[#061330] transition-colors">View comparison</Link>
      </div>
    </div>
  );
};
